var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585786 2.58774C0.960859 2.21267 1.46957 2.00195 2 2.00195H5.33333C5.70152 2.00195 6 2.30043 6 2.66862C6 3.03681 5.70152 3.33529 5.33333 3.33529H2C1.82319 3.33529 1.65362 3.40552 1.5286 3.53055C1.40357 3.65557 1.33333 3.82514 1.33333 4.00195V10.002C1.33333 10.1788 1.40357 10.3483 1.5286 10.4734C1.65362 10.5984 1.82319 10.6686 2 10.6686H8C8.17681 10.6686 8.34638 10.5984 8.47141 10.4734C8.59643 10.3483 8.66667 10.1788 8.66667 10.002V6.66862C8.66667 6.30043 8.96514 6.00195 9.33333 6.00195C9.70152 6.00195 10 6.30043 10 6.66862V10.002C10 10.5324 9.78929 11.0411 9.41421 11.4162C9.03914 11.7912 8.53043 12.002 8 12.002H2C1.46957 12.002 0.960859 11.7912 0.585786 11.4162C0.210714 11.0411 0 10.5324 0 10.002V4.00195C0 3.47152 0.210714 2.96281 0.585786 2.58774Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8047 0.197215C12.0651 0.457565 12.0651 0.879675 11.8047 1.14002L5.13807 7.80669C4.87772 8.06704 4.45561 8.06704 4.19526 7.80669C3.93491 7.54634 3.93491 7.12423 4.19526 6.86388L10.8619 0.197215C11.1223 -0.0631343 11.5444 -0.0631343 11.8047 0.197215Z",
    fill: "#818181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 0.66862C7.33333 0.30043 7.63181 0.00195313 8 0.00195313H11.3333C11.7015 0.00195313 12 0.30043 12 0.66862V4.00195C12 4.37014 11.7015 4.66862 11.3333 4.66862C10.9651 4.66862 10.6667 4.37014 10.6667 4.00195V1.33529H8C7.63181 1.33529 7.33333 1.03681 7.33333 0.66862Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.f47a88712c867639939c8de7c7902b7a.svg";
export { ForwardRef as ReactComponent };